module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.9c7e4e9e.woff";